require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./mdiation-1-9-6.json") })
        }
      }, "path---mdiation-1-9-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---mdiation-1-9-6!./.cache/json/mdiation-1-9-6.json
// module id = 494
// module chunks = 231608221292675